import block from 'bem-cn-lite';
import {Text} from '@gravity-ui/uikit';
import {getActivatableProps} from '@hooks/keyboard';

import './Card.scss';

const b = block('home-page-card');

interface CardProps {
    text: string;
    icon: string;
    onClick: () => void;
}

export const Card: React.FC<CardProps> = ({text, icon, onClick}) => {
    return (
        <div className={b()} data-kbd-row {...getActivatableProps(onClick)}>
            <img src={icon} alt={text} />
            <Text variant="header-1">{text}</Text>
        </div>
    );
};
